import { MicroApp } from '@/types/micro-app'

/**
 * 微应用配置列表
 */
const microApps: MicroApp[] = [
  {
    name: 'app1',
    entry: import.meta.env.PROD
      ? '//localhost:8081/'
      : '//localhost:8081/',
    container: '#micro-container',
    activeRule: '/micro-app/app1',
    props: {
      baseName: '/micro-app/app1'
    }
  },
  {
    name: 'app2',
    entry: import.meta.env.PROD
      ? '//localhost:8082/'
      : '//localhost:8082/',
    container: '#micro-container',
    activeRule: '/micro-app/app2',
    props: {
      baseName: '/micro-app/app2'
    }
  }
]

export default microApps 